import { useFlags } from '@mint-lib/routing-context';

export const useNativeMetricsPlatformMediaRow = () => {
  const ff = useFlags('@mint/arm', ['nativeMetricsPlatformMediaRow']);

  return ff.nativeMetricsPlatformMediaRow.enabled;
};
